(function($) {
	'use strict';

	/**
	 * Calculate maturity scores by level per category
	 * @param {Object} categorizedScores - Categorized scores object
	 * @param {boolean} isLegacyMode - Whether in legacy mode
	 * @returns {Object} - Maturity scores by level
	 */
	function calculateMaturityScoresByLevelPerCategory(categorizedScores, isLegacyMode = false) {
		// console.log('=== CALCULATE MATURITY SCORES BY LEVEL START ===');
		// console.log('isLegacyMode:', isLegacyMode);
		// console.log('categorizedScores categories:', Object.keys(categorizedScores));
		
		// Create a deep copy of the categorizedScores to avoid modifying the original
		const cleanedCategorizedScores = JSON.parse(JSON.stringify(categorizedScores));
		const results = {};
		
		// Use different level sets based on mode
		const levels = isLegacyMode ?
			["P1", "P2", "P3", "P4", "P5"] :
			["Foundational (Level 1)", "Hygiene (Level 2)", "Governed (Level 3)", "Controlled (Level 4)", "Monitored (Level 5)"];

		// Alternate keys in case data was stored under P1-P5 (e.g. from legacy path or API variant)
		const levelToAlternates = isLegacyMode ? null : {
			"Foundational (Level 1)": ["P1"],
			"Hygiene (Level 2)": ["P2"],
			"Governed (Level 3)": ["P3"],
			"Controlled (Level 4)": ["P4"],
			"Monitored (Level 5)": ["P5"]
		};
		const getLevelData = (topicData, level) => {
			if (topicData[level] && typeof topicData[level] === 'object') return topicData[level];
			if (levelToAlternates && levelToAlternates[level]) {
				for (let i = 0; i < levelToAlternates[level].length; i++) {
					const alt = levelToAlternates[level][i];
					if (topicData[alt] && typeof topicData[alt] === 'object') return topicData[alt];
				}
			}
			return null;
		};

		// console.log('Levels being calculated:', levels);

		// Initialize results structure with overall and per-category level details
		results['Overall'] = {};
		levels.forEach(level => {
			results['Overall'][level] = { totalScore: 0, count: 0, active: false };
		});

		// console.log('Step 1: Calculating category-level scores...');
		Object.keys(cleanedCategorizedScores).forEach(category => {
			results[category] = {};
			levels.forEach(level => {
				let levelFilledScore = 0;
				let levelFilledCount = 0;
				let levelNAItems = 0;
				let levelPotentialItems = 0;
				Object.keys(cleanedCategorizedScores[category]).forEach(topic => {
					if (topic === 'overallMaturityScore') return;
					const topicData = cleanedCategorizedScores[category][topic];
					const levelData = getLevelData(topicData, level);
					if (levelData) {
						const filledCount = levelData.filledItems ? levelData.filledItems.length : 0;
						const naCount = levelData.naItems ? levelData.naItems.length : 0;
						const potentialCount = levelData.potentialCount || 0;
						const totalScore = levelData.totalScore || 0;
						levelFilledScore += totalScore;
						levelFilledCount += filledCount;
						levelNAItems += naCount;
						levelPotentialItems += potentialCount;
					}
				});
				const denominator = levelPotentialItems - levelNAItems;
				let result = 'Not Applicable';
				if (denominator > 0) {
					const avg = levelFilledScore / denominator;
					result = avg * 5;
				}
				results[category][level] = result;
			});
		});

	// Calculate overall scores for each level
	// console.log('Step 2: Calculating overall scores for each level...');
	
	// First, calculate distribution by level
	const levelDistribution = {};
	levels.forEach(level => {
		let totalPotentialItems = 0;
		Object.keys(results).forEach(category => {
			if (category !== 'Overall') {
				let levelPotentialItems = 0;
				Object.keys(cleanedCategorizedScores[category]).forEach(topic => {
					if (topic === 'overallMaturityScore') return;
					const topicData = cleanedCategorizedScores[category][topic];
					const levelData = getLevelData(topicData, level);
					if (levelData) {
						const potentialCount = levelData.potentialCount || 0;
						levelPotentialItems += potentialCount;
					}
				});
				totalPotentialItems += levelPotentialItems;
			}
		});
		levelDistribution[level] = totalPotentialItems;
	});
	// console.log('Safeguard distribution by level:', levelDistribution);
	
	levels.forEach(level => {
		// console.log(`  Calculating ${level} level...`);
		let totalScore = 0;
		let totalDenominator = 0;
		Object.keys(results).forEach(category => {
			if (category !== 'Overall') {
				const val = results[category][level];
				if (typeof val === 'number') {
					let levelFilledScore = 0;
					let levelNAItems = 0;
					let levelPotentialItems = 0;
					Object.keys(cleanedCategorizedScores[category]).forEach(topic => {
						if (topic === 'overallMaturityScore') return;
						const topicData = cleanedCategorizedScores[category][topic];
						const levelData = getLevelData(topicData, level);
						if (levelData) {
							const naCount = levelData.naItems ? levelData.naItems.length : 0;
							const potentialCount = levelData.potentialCount || 0;
							const totalScore = levelData.totalScore || 0;
							levelFilledScore += totalScore;
							levelNAItems += naCount;
							levelPotentialItems += potentialCount;
						}
					});
					totalScore += levelFilledScore;
					totalDenominator += (levelPotentialItems - levelNAItems);
				}
			}
		});
		
		// console.log(`    ${level} - Total score: ${totalScore}, Potential safeguards: ${levelDistribution[level]}`);
		// console.log(`    ${level} - Denominator (potential - NA): ${totalDenominator}`);
		
		let overallResult = 'Not Applicable';
		if (totalDenominator > 0) {
			const avg = totalScore / totalDenominator;
			overallResult = avg * 5;
			// console.log(`    ${level} - Final average: ${overallResult.toFixed(2)} (raw: ${avg})`);
		} else {
			// console.log(`    ${level} - No valid items, setting to Not Applicable`);
		}
		results['Overall'][level] = overallResult;
	});

	// console.log('=== CALCULATE MATURITY SCORES BY LEVEL END ===');
	// console.log('Final overall results:', results['Overall']);

	return {
		results: results,
		cleanedCategorizedScores: cleanedCategorizedScores
	};
}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { calculateMaturityScoresByLevelPerCategory };
	} else if (typeof window !== 'undefined') {
		window.calculateMaturityScoresByLevelPerCategory = calculateMaturityScoresByLevelPerCategory;
	}

})(jQuery);
